// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"138":"a1757645","180":"0060db96","239":"6fb671fa","453":"2cc6eec0","732":"16cd1a87","977":"cc7ccab9"}[chunkId] + ".chunk.js";
};